import React from "react";
import "./nav.css";
import NavLink from "../../components/nav-link/nav-link-component";
import heart from "./heart.png";

const Nav = (
  {
    logout,
    token,
    previousPages,
    goBack,
    goHome,
    backToReportsList,
    location,
    goToAddReport
  }
  ) => (
  <div className="nav_container shadow">
    <nav className="nav_container__nav">
      <NavLink
        handler={goHome}
        style={{position: 'absolute', left: '0'}}
        hoverColor="#f26522"
      >
        <div className="nav_container__home_icon">
          <i className="far fa-heart" style={{fontSize: '30px'}} />
        </div>
      </NavLink>
      {
        [
          "/add-taxonomy",
          "/hb-index-chart",
          "/report/top-words",
          "/report/primary-emotions",
          "/report/sentiment",
          "/word-verbatims"].includes(location.pathname)
        ?
          <NavLink
            name="Back"
            handler={() => goBack({ showModal: location.pathname === '/add-taxonomy' })}
          >
            <div className="">
              <i className="fas fa-arrow-left" />
            </div>
          </NavLink>
          :
          null
      }
      {
        ["/report", "/add-report"].includes(location.pathname)
        ?
          <NavLink
            name="Back to Reports List"
            handler={backToReportsList}
          >
            <div className="">
              <i className="fas fa-arrow-left" />
            </div>
          </NavLink>
          :
          null
      }
      {
        location.pathname === '/reports'
        ?
          <NavLink
            name="Add report"
            handler={goToAddReport}
          >
            <div className="nav_container__nav__link__icon">
              <i className="far fa-plus-square" />
            </div>
          </NavLink>
          :
          null

      }

      {
        token &&
        <NavLink
          style={{ position: "absolute", right: "0" }}
          name="Logout"
          handler={logout}
        >
          <div className="nav_container__nav__link__icon">
            <i className="fas fa-sign-out-alt" />
          </div>
        </NavLink>
      }
    </nav>
  </div>
);

export default Nav;



// WEBPACK FOOTER //
// ./src/modules/nav/nav-component.js